import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Button,
  Box,
  ModalHeader,
  ModalFooter,
  useBreakpointValue,
  Spinner,
  Flex,
  Tooltip,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import { AppContext } from "AppProvider/AppContext";
import AddComentModal from "../../AddComentModal/AddComentModal";
import CurbeyTable from "App/CurbeyTable";
import CommentDrawer from "../../CommentDrawer/CommentDrawer";
import { downloadExcel } from "./element/downloadCurebayData";
import { FiDownload } from "react-icons/fi";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  file: any;
  values?: any;
  showValues?: boolean;
  level?: any;
  id?: any;
  getData?: any;
  commentData?: string;
  isManual: boolean;
  isDisabled?: boolean;
  documentId?: any;
  type?: string;
  tagType?: string;
  documentType?: any;
  name?: string;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  handleGet: () => void;
};

export default function CurbayViewerModel({
  isOpen,
  onClose,
  file,
  values,
  showValues,
  id,
  level,
  getData,
  isDisabled = false,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  handleGet,
  name,
}: ModalProps): JSX.Element {
  const [formData, setFormData] = useState({});
  const { toastNotify, accountDetails } = useContext(AppContext);
  const [isloading, setIsLoading] = useState(false);
  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [comment, setComment] = useState(commentData!=="-" ? commentData : '');
  const [comment, setComment] = useState("");

  function getLastValidateObject(arr: any) {
    for (let i = arr.length - 1; i >= 0; i--) {
      if (arr[i] !== null && arr[i] !== undefined) {
        return arr[i];
      }
    }
    return {};
  }

  useEffect(() => {
    let displayValues = {};
    if (!Array.isArray(values)) {
      displayValues = values?.values || {};
    }
    if (Array.isArray(values) && values?.length) {
      const lastObject = getLastValidateObject(values);
      displayValues = lastObject.values || {};
    }
    setFormData(displayValues);
  }, []);

  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  useEffect(() => {
    if (isOpen) {
      getFile();
    }
  }, [isOpen]);

  const handleInvOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleInvCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseCommentModal = () => {
    setIsCommentOpen(false);
  };

  const handleOpenCommentModal = () => {
    setIsCommentOpen(true);
  };

  const isCommentValid = () => {
    return comment.trim() !== "";
  };

  const getFile = async () => {
    try {
      if (file?._id) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            setSample({
              url: fileURL,
              file: file,
              type: file.metadata.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const viewerWidth = useBreakpointValue({ lg: true });

  let width =
    values && showValues && Object.entries(values)?.length > 0
      ? "95vw"
      : "45vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={viewerWidth ? width : "100vw"}
        animation={`${
          isOpen ? "slideIn" : "slideOut"
        } 0.8s ease-in-out forwards`}
      >
        <Flex justifyContent="space-between" width={"95%"} alignItems="center">
          <ModalHeader
            fontSize={{ base: "md", lg: "lg" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem"
            ml="1rem"
          >
            Document
          </ModalHeader>
          <Button
            onClick={() => downloadExcel([formData])}
            colorScheme="teal"
            variant="solid"
            size="sm"
            fontWeight="medium"
            _hover={{ bg: "teal.600", color: "white" }}
            leftIcon={<FiDownload />}
          >
            <Tooltip aria-label="Download Tooltip">Download</Tooltip>
          </Button>
        </Flex>
        <ModalCloseButton />
        <ModalBody
          px={{ base: ".5rem", lg: "1.5rem" }}
          py=".2rem"
          overflowY="auto"
          className="customScrollBar"
          mb={{ base: "1rem", lg: "unset" }}
        >
          <Box
            display={{ base: "grid", lg: "flex" }}
            flexDirection={{ base: "column", lg: "row" }}
            gap={{ base: 1, lg: 6 }}
            h="100%"
          >
            {fetchFileLoader ? (
              <Box
                h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                mb="1rem"
                w="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Spinner
                  size="xl"
                  thickness="4px"
                  speed="0.65s"
                  color="teal.400"
                />
              </Box>
            ) : (
              <Box
                h={{ base: "30vh", md: "40vh", lg: "85vh" }}
                w={{ lg: "40vw" }}
              >
                <FileViewer sample={sample} />
              </Box>
            )}
            <Box>
              {values && showValues && (
                <Box
                  h={!isDisabled ? "85vh" : "85vh"}
                  w={{ lg: "55vw" }}
                  p={{ base: ".6rem", lg: ".6rem .5rem" }}
                  overflowY="auto"
                  className="customScrollBar"
                  onWheel={handleModalWheel}
                  border="2px solid"
                  borderColor="teal.400"
                  rounded={4}
                  mb={2}
                >
                  <CurbeyTable formData={formData} setFormData={setFormData} />
                </Box>
              )}
              {/* {!isDisabled && (
                <Box mt="0.5rem">
                  <Input
                    value={comment}
                    placeholder="Add a comment"
                    onChange={handleTextareaChange}
                  />
                </Box>
              )} */}
            </Box>
          </Box>
        </ModalBody>
        {!isDisabled &&
          accountDetails.role !== "admin" &&
          name === "Pending Approval" &&
          accountDetails?.role === "approver" && (
            <ModalFooter p="0.5rem">
              <Button
                isDisabled={isloading}
                onClick={() => {
                  // handleDocUpdate('approved',level,id)
                  setCommentModel({
                    open: true,
                    selectedStatus: "approved",
                    comment: "",
                    isMulti: false,
                  });
                }}
                fontSize="sm"
                bg="green.500"
                color="white"
                _hover={{ bg: "green.600" }}
                mr="1rem"
                w="100px"
              >
                Accept
              </Button>
              <Button
                isDisabled={isloading}
                onClick={() =>
                  setCommentModel({
                    open: true,
                    selectedStatus: "rejected",
                    comment: "",
                    isMulti: false,
                  })
                }
                bg="red.500"
                _hover={{ bg: "red.600" }}
                color="white"
                w="100px"
                mr="14px"
              >
                Reject
              </Button>
            </ModalFooter>
          )}
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
      </style>
      <CommentDrawer
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        commentModel={commentModel}
        setCommentModel={setCommentModel}
        handleGet={handleGet}
        view={true}
        isOpen={commentModel.open}
        width={width}
        onClose={handleCloseCommentModal}
        handleClose={onClose}
        selectedFile={file}
        editedValues={formData}
      />
    </Modal>
  );
}
